import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProductLink } from '../models/models'

export class ProductLinkInsertApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productLink/Insert',
      requesterInfo,
    })
  }

  public async productLinkInsert(request: IProductLink): Promise<IProductLink> {
    return await this.postAsync<IProductLink>(request)
  }
}
